// extracted by mini-css-extract-plugin
module.exports =  {"title":"_2787e5dfdf--title--NdcTv","house":"_2787e5dfdf--house--_KWbu","subtitle":"_2787e5dfdf--subtitle--Qs4G5"};